import React, { useState, useEffect } from "react";
import {
  SearchOutlined,
  FileAddOutlined,
  SaveOutlined,
  FolderOpenOutlined,
  EditOutlined,
  DeleteOutlined,
  LikeOutlined,
  DislikeOutlined,
  LeftOutlined,
} from "@ant-design/icons";
import {
  Layout,
  Button,
  theme,
  ConfigProvider,
  FloatButton,
  Input,
  Row,
  Typography,
  Col,
  Card,
  Select,
  Breadcrumb,
  Form,
  DatePicker,
  Collapse,
  Spin,
  Checkbox,
} from "antd";
import dayjs from "dayjs";
import menuItems from "../../../config/data/menus.json";
import FloatButtonComp from "../../../components/FloatButtonComp";
import { useNavigate, Link } from "react-router-dom";
import "../../../assets/styles/DatePicker.css";
import BreadcrumbItem from "antd/es/breadcrumb/BreadcrumbItem";
import MainLayout from "../../../components/layouts/MainLayout";
import RecordStatus from "../../../components/RecordStatus";
import ContentTop from "../../../components/ContentTop";
import tableData from "../../../config/data/loanProducts.json";
import CustomButton from "../../../components/custom/CustomButton";

const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;

const ViewSYA0100 = () => {
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [selectedKey, setSelectedKey] = useState("/sya0100");
  const [switchLabel, setSwitchLabel] = useState("Dark Mode");
  const [switchLabelColor, setSwitchLabelColor] = useState("#aeaeae");
  const [menuBG, setMenuBG] = useState("#2F172D");
  const [searchColorBgContainer, setSearchColorBgContainer] =
    useState("#3B2639");
  const [menuTheme, setMenuTheme] = useState("dark");
  const [leftLayoutMargin, setLeftLayoutMargin] = useState(190);
  const [logoDimensions, setLogoDimensions] = useState(100);
  const [menuSearchBarState, setMenuSearchBarState] = useState(false);
  const [menuSearchIconState, setMenuSearchIconState] = useState(true);
  const [switchLabelState, setSwitchLabelState] = useState(false);

  function onSwitchClick() {
    if (switchLabel === "Dark Mode") {
      setSwitchLabel("Light Mode");
      setMenuBG("#fff");
      setSearchColorBgContainer("#f7f8fa");
      setSwitchLabelColor("#8c8f9f");
      setMenuTheme("light");
    } else {
      setSwitchLabelColor("#aeaeae");
      setSwitchLabel("Dark Mode");
      setMenuBG("#2F172D");
      setSearchColorBgContainer("#3B2639");
      setMenuTheme("dark");
    }
  }

  function onMenuSelect(menuItems) {
    // console.log(menuItems.key);
    setSelectedKey(menuItems.key);
    navigate(menuItems.key, { replace: false });
  }

  useEffect(() => {
    if (collapsed === true) {
      setLeftLayoutMargin(71);
      setLogoDimensions(50);
      setMenuSearchBarState(true);
      setMenuSearchIconState(false);
      setSwitchLabelState(true);
    } else {
      setLeftLayoutMargin(190);
      setLogoDimensions(100);
      setMenuSearchBarState(false);
      setMenuSearchIconState(true);
      setSwitchLabelState(false);
    }
  });

  const {
    token: { colorBgContainer },
  } = theme.useToken();
  return (
    <ConfigProvider
      theme={{
        components: {
          Layout: {
            siderBg: menuBG,
          },
          Menu: {
            darkItemBg: menuBG,
            darkSubMenuItemBg: "#241223",
          },
        },
      }}
    >
      <MainLayout
        collapsed={collapsed}
        searchColorBgContainer={searchColorBgContainer}
        theme={menuTheme}
        defaultSelectedKeys={selectedKey}
        items={menuItems}
        onClick={onMenuSelect}
        switchLabel={switchLabel}
        onSwitchClick={onSwitchClick}
        switchLabelColor={switchLabelColor}
        logoDimensions={logoDimensions}
        menuSearchBarState={menuSearchBarState}
        menuSearchIconState={menuSearchIconState}
        switchLabelState={switchLabelState}
        setCollapsed={setCollapsed}
        leftLayoutMargin={leftLayoutMargin}
        colorBgContainer={colorBgContainer}
      >
        <MainPage titleOfPage={"View Account Number Preferences"} />
        <RecordStatus
          authStatus={"Authorised"}
          makerID={""}
          makerDate={"2023-10-27"}
          checkerID={" "}
          checkerDate={"2023-10-27"}
        />
      </MainLayout>
    </ConfigProvider>
  );
};

function FloatButtonGroup(props) {
  return (
    <FloatButton.Group
      shape="square"
      style={{
        right: 20,
        bottom: "40%",
      }}
      type="primary"
    >
      <FloatButtonComp
        icon={EditOutlined}
        tooltip="Edit"
        theme="primary"
        onClick={props.onEditClick}
      />
      <FloatButtonComp icon={DeleteOutlined} tooltip="Delete" theme="primary" />
      <FloatButtonComp icon={LikeOutlined} tooltip="Approve" theme="primary" />
      <FloatButtonComp
        icon={DislikeOutlined}
        tooltip="Disapprove"
        theme="primary"
      />
      <FloatButton.BackTop
        visibilityHeight={0}
        tooltip={<div>Back to Top</div>}
      />
    </FloatButton.Group>
  );
}

function MainPage(props) {
  const navigate = useNavigate();
  const [editing, setEditing] = useState(true); // This is reffering to the 'disabled' API of the the Text Boxes, etc. True means that 'disabled' = true.
  // const [editModeButtonsState, setEditModeButtonsState] = useState(true)

  function HandleEditClick() {
    if (editing === true) {
      setEditing(false);
    } else {
      setEditing(true);
    }
  }

  function onEditModeCancel() {
    setEditing(true);
  }

  function backOnClick() {
    navigate("/sya0100", { replace: true });
  }

  return (
    <div style={{ marginBottom: 50 }}>
      <FloatButtonGroup onEditClick={HandleEditClick} />
      <ContentTop titleOfPage={"View Account Number Preferences"}>
        <BreadcrumbItem>
          <a href="/dashboard">Home</a>
        </BreadcrumbItem>
        <BreadcrumbItem>
          <a href="/sya0100">Account Number Preferences</a>
        </BreadcrumbItem>
        <BreadcrumbItem>
          <Text>View Account Number Preferences</Text>
        </BreadcrumbItem>
      </ContentTop>
      <div>
        <ViewSYA0100Form
          backOnClick={backOnClick}
          disabled={editing}
          onEditCancel={onEditModeCancel}
          formButtonState={editing}
        />
      </div>
      <Row gutter={16}></Row>
    </div>
  );
}

function ViewSYA0100Form(props) {
  const [addPrefixToAccount, setAddPrefixToAccount] = useState(false);
  const navigate = useNavigate();

  function onCancel() {
    navigate("/sya0100", { replace: false });
  }

  const onSubmit = (values) => {
    console.log("Success:", values);
  };

  return (
    <Form layout="vertical" style={{ paddingTop: 20 }} onFinish={onSubmit}>
      <Card
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        <Card
          style={{
            marginBottom: "2%",
            boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          }}
        >
          <Row style={{ justifyContent: "space-between" }}>
            <Col span={12}>
              <Form.Item
                name="selectAccountType"
                label={<Text strong>Select Account Type</Text>}
              >
                <Select
                  disabled={props.disabled}
                  placeholder="Select Account Type"
                  style={{ width: "30vh" }}
                  options={[
                    { value: "Client", label: "Client" },
                    { value: "Loan", label: "Loan" },
                    { value: "Savings", label: "Savings" },
                    { value: "Center", label: "Center" },
                    { value: "Group", label: "Group" },
                    { value: "Shares", label: "Shares" },
                  ]}
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item name="addPrefixToAccount">
                <Checkbox
                  disabled={props.disabled}
                  style={{ width: "30vh" }}
                  onChange={() => setAddPrefixToAccount(!addPrefixToAccount)}
                >
                  <Text strong>Add Prefix to Account </Text>
                </Checkbox>
              </Form.Item>

              {!addPrefixToAccount && (
                <Form.Item
                  name="prefixField"
                  label={<Text strong>Prefix Field</Text>}
                >
                  <Select
                    placeholder={"Select Prefix Field"}
                    showSearch
                    style={{ width: "30vh" }}
                    disabled={props.disabled}
                  />
                </Form.Item>
              )}
            </Col>
          </Row>
        </Card>
        <Form.Item>
          {!props.formButtonState && (
            <Row>
              <CustomButton
                content="Submit"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                htmlType="submit"
                backgroundColor="#92428B"
                colorText="white"
                hoverBackground="#AD4EA7"
              />
              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          )}
        </Form.Item>
      </Card>
    </Form>
  );
}

export default ViewSYA0100;
